import './App.css';
import React, { useState, useMemo, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { UserContext } from "./Components/UserContext";
import { ContextProvider } from './SocketContext';
import AlertPage from './Components/AlertPage'
import TopBarMobUI from './Components/MobUI/TopBarMobUI';
import FooterMobUI from './Components/MobUI/FooterMobUI';
import FooterUI from './Components/PC/FooterUI';
import NewNavbarUI from './Components/PC/NewNavbarUI';
import NewTopBarMobUI from './Components/MobUI/NewTopBarMobUI';
import PublicRoutes from './Components/Routes/PublicRoutes';
import PrivateRoutes from './Components/Routes/PrivateRoutes';
import { WidthFull } from '@mui/icons-material';

const App = () => {

  const [user, setUser] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = React.useState(false);

  const showAlert = (message, type) => {

    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null)
    }, 3000);
  }

  //snack bar
  const handleClick = () => {
    setOpen(true);
  };

  //snackbar
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const value = useMemo(
    () => ({
      user,
      setUser,
    }),
    [
      user,
      setUser,
    ]
  );

  useEffect(() => {
    
    let storedUser = localStorage.getItem("loggedInUser");

    if (storedUser) {

      setUser(JSON.parse(storedUser));


    }
    setIsMobile((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)))
  }, []);

  // useEffect(()=>{
  // clearInterval();
  // setInterval(()=>checkUserValidity(),300000);
  // },[user]);

  useEffect(()=>{

  },[alert]);


  const checkUserValidity = async () => {
    if (user != null) {
      let apiURL = process.env.REACT_APP_API_URL + "/users/checkuservalidity/" + user._id;
      let apiParams = {
        method: "GET",
        headers: {
          authtoken: localStorage.getItem("loggedintoken")
        }
      };
      await fetch(apiURL, apiParams)
        .then((res) => (res.status === 200 ? res.json() : res.text()))
        .then((repos) => {
          if (repos.data) {
            if ((repos.data.active !== true) || (repos.data.accesstype !== user.accesstype)) {
              window.logout();//handlelogout();
              console.log('what is it no error')
            }
          } else console.log('what is it',JSON.stringify(repos));
        })
        .catch((err) => console.log(JSON.stringify(err)));
    }
  };


  const handlelogout = () => {
    localStorage.clear();
    setUser(null);
    window.location.href = "/";
  }


  return (
    <UserContext.Provider value={value}>
      <Router>
        {(window.location.pathname === "/vacancies" || user) && ((!isMobile && ((user && user.accesstype !== "c") && (user && user.accesstype !== "r")))) ? <><NewNavbarUI showAlert={showAlert} />
          <br />
          <br />
          <br />
        </>
          : user && (isMobile && (user.accesstype === "c" || user.accesstype === "r")) ? <><TopBarMobUI /><FooterMobUI /></>
            : user && (!isMobile && (user.accesstype === "c" || user.accesstype === "r")) ? <><FooterUI /></>
              : (isMobile && ((user && user.accesstype !== "c") && (user && user.accesstype !== "r")) ? <><NewTopBarMobUI /></> : "")}


        {alert === null ? "" : <AlertPage alert={alert}/>}

        {/* <SnackBar handleClick={setOpen(true)} handleClose={handleClose} /> */}

        {/* <ResponsiveAppBar/> */}
        <ContextProvider>
          {!user || !user.accesstype ? <PublicRoutes isMobile={isMobile} showAlert={showAlert} /> : <PrivateRoutes isMobile={isMobile} showAlert={showAlert} />}
</ContextProvider>
      </Router>
    </UserContext.Provider>
  )
}

export default App;
